export const SUPER_ADMIN = "superadmin";
export const SUPER_ADMIN_EDITOR = "superadmineditor";
export const DEVELOPER = "developer";
export const ADMIN = "admin";
export const ACTING_ADMIN = "actingadmin";
export const EDITOR_ADMIN = "editoradmin";
export const VIWEER_ADMIN = "vieweradmin";
export const WHITE_LABEL_ADMIN = "whitelabeladmin";

export const SUB_ADMIN = "subuser";

const ROLES = {
  SUPER_ADMIN,
  SUPER_ADMIN_EDITOR,
  DEVELOPER,
  ADMIN,
  ACTING_ADMIN,
  EDITOR_ADMIN,
  VIWEER_ADMIN,
  SUB_ADMIN,
};

export default ROLES;
